<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Status Atual: {{ dados.nomeStatus }}</span>
          <br />
          <br />

          <span>Novo Status:</span>
          <v-select
            :options="status"
            name="Status"
            id="Status"
            v-model="formCadastro.idStatus"
            v-validate="{ required: true }"
            :state="validateState('Status')"
            :class="validateClass('Status')"
          ></v-select>
        </div>

        <div v-if="showMotivo" class="vx-col w-full mt-3">
          <span>Motivo da Recusa</span>
          <vs-input
            size="large"
            class="w-full"
            name="Motivo"
            id="Motivo"
            v-model="formCadastro.restricaoDescricao"
            v-validate="{ required: true }"
            :state="validateState('Motivo')"
            :danger="validateClass('Motivo')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>

        <div class="vx-col w-full mt-5">
          <span>Fotos a serem Resetadas:</span>
          <v-select
            :options="fotos"
            name="Fotos"
            id="Fotos"
            multiple
            v-model="formCadastro.fotos"
            :state="validateState('Fotos')"
            :class="validateClass('Fotos')"
          ></v-select>
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idProposta"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import { decryptData } from '../../services/decryptData';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      status: [],
      fotos: [],
      languages: lang,
      showMotivo: false,
      estado: null,
      funcoesValicao: null,
      formCadastro: {
        idProposta: null,
        idEmpresa: null,
        idStatus: null,
        fotos: [],
        restricaoDescricao: null,
      },
    };
  },
  created: function () {
    this.$watch('formCadastro', this.formUpdated, {
      deep: true,
    });
  },
  methods: {
    preencheForm() {
      if (this.dados.idProposta) {
        this.formCadastro.idProposta = this.dados.idProposta;
        this.formCadastro.idStatus = this.dados.idStatus;
        this.formCadastro.restricaoDescricao = this.dados.restricaoDescricao;
        this.buscaFotosPorProposta();
      } else {
        this.resetForm();
      }
    },
    formUpdated: function (newValue) {
      if (newValue.idStatus)
        if (newValue.idStatus.id === 2) {
          this.showMotivo = true;
        } else {
          this.showMotivo = false;
        }
    },
    async buscaFotosPorProposta() {
      const objSend = {};
      objSend.idProposta = this.dados.idProposta;
      objSend.idEmpresa = this.dados.idEmpresa;
      objSend.idGrupo = this.dados.idGrupo;
      objSend.idTipoFipe = this.dados.dadosVeiculo.codTipoVeiculo;
      try {
        this.$vs.loading();
        const { data } = await service.post(
          'Cotacao',
          'listarFotosCotacao',
          objSend,
        );
        data.forEach((element) => {
          const aux = this.fotos.filter(
            (image) => image.id === element.id_modeloFoto,
          );
          if (aux.length === 0)
            this.fotos.push({
              id: element.id_modeloFoto,
              label: element.nomePosicao,
            });
        });
        this.isMounted = true;
      } catch (e) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: e,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('Cotacao', `AtualizaPropostaAdm`, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },

    keymonitor: function (event) {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        const cepbusca = this.formCadastro.cep
          .replace('.', '')
          .replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            res.data = decryptData(res.data);
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
    resetForm() {
      this.formCadastro = {
        idRegional: null,
        idEmpresa: null,
        status: true,
        nome: '',
        cidade: '',
        estado: '',
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  mounted() {
    this.buscaDadosSelects(
      'domStatusCotacao',
      'status',
      'nomeStatus',
      'idStatus',
    );
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
